import ShopRoutes from './shop.routes';

export default ShopRoutes;
